import React from 'react';

import { SvgProps } from 'components/UI/Svg/Svg';
import { Color } from 'modules/styles/colors';
import { SNavStyles } from './index';
import { getFillColor, getStrokeColor, getStrokeWidth } from './utils';

export default (props: SvgProps | undefined) => {
  const getFill = getFillColor(
    props?.active,
    props?.activeFillColor,
    props?.disabled,
    props?.disabledColor,
    props?.color
  );

  return {
    svg: (
      <g
        {...SNavStyles}
        strokeWidth={getStrokeWidth(props?.strokeWidth)}
        fill={getFill}
        stroke={getStrokeColor(
          props?.active,
          props?.activeStrokeColor,
          props?.disabled,
          props?.disabledColor,
          props?.stroke || props?.color
        )}
      >
        <polygon points="5.79,5.14 5.79,24.99 11.95,24.99 11.95,30.86 16.49,24.99 29.7,24.99 29.7,5.14 " />
        <g
          {...SNavStyles}
          strokeWidth={getStrokeWidth(props?.strokeWidth)}
          stroke={getStrokeColor(
            props?.active,
            Color.white,
            props?.disabled,
            props?.disabledColor,
            props?.stroke || props?.color
          )}
        >
          <line x1="11.05" y1="10.38" x2="24.59" y2="10.38" />
          <line x1="11.05" y1="14.99" x2="24.59" y2="14.99" />
          <line x1="11.05" y1="19.6" x2="24.59" y2="19.6" />
        </g>
      </g>
    ),
    viewBox: '0 0 36 36'
  };
};
